/**
 * app/(pay)/_layout.tsx — PUBLIC, web-hosted pay-by-invoice surface (2026-06-27).
 *
 * Anonymous customers land here from a business's pay link (getabeam.com/pay/<slug>), a verified
 * custom domain, or an embedded widget. No BEAM session is required — the root AuthGate leaves this
 * group alone on web (like (marketing)). The actual card entry happens on Stripe Checkout, on the
 * business's OWN connected account; no card data ever touches this app (mobile invariant 2).
 */
import { Stack } from 'expo-router';
import { theme } from '../../src/theme';

export default function PayLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.color.bg.app },
      }}
    >
      <Stack.Screen name="pay/index" options={{ title: 'Pay an invoice' }} />
      <Stack.Screen name="pay/[slug]/index" options={{ title: 'Pay an invoice' }} />
      <Stack.Screen name="pay/[slug]/[number]" options={{ title: 'Pay an invoice' }} />
    </Stack>
  );
}
